// Compatibility export for old Search.styles imports

// eslint-disable-next-line no-restricted-imports
import { Search as DSSearch } from "@packages/ds";

// Export the input component for backward compatibility
export const Search = DSSearch.Input;
